module.exports = __webpack_public_path__ + "static/media/Att_strip.ee46c719.png";